import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse } from '@services/providers/cosem.types';
import { ActiveFilter } from '@utils/filters';
import { BookingStatus, BookingTable } from './booking.types';

const bookingApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        /** Vue transversale : toutes les réservations, tous logements confondus */
        getBookings: build.mutation<
            ApiPaginationResponse<BookingTable>,
            {
                status?: BookingStatus;
                apartmentId?: number | null;
                limit?: number;
                page?: number;
                search?: string;
                orderBy?: string;
                filters?: ActiveFilter[];
            }
        >({
            query: ({ status = 'upcoming', apartmentId, limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/member/bookings`,
                    method: 'GET',
                    params: {
                        status,
                        ...(apartmentId ? { apartmentId } : {}),
                        limit,
                        page,
                        search: search ?? '',
                        orderBy: orderBy ?? '',
                        filters: JSON.stringify(filters ?? [])
                    }
                };
            },
            transformResponse: (response: ApiPaginationResponse<BookingTable>) => response
        })
    })
});

export const { useGetBookingsMutation } = bookingApi;
